export interface FidcTaxa { empregador: number; regime: string; jurosOperacao: number; taxaCessao: number; }
export interface FidcElegibilidade { regimes: string[]; produtos: number[]; empregadores: number[]; originadores: number[]; idadeMaxima: number; prazoMaximo: number; taxas: FidcTaxa[]; }
export class Fidc {
  codigoExterno = '';
  prioridade: number | null = null;
  ativo = true;
  disponivel = true;
  limiteDiario = 0;
  limiteDiarioUtilizado = 0;
  saldoDisponivel = 0;
  justificativa = '';
  elegibilidade: FidcElegibilidade = { regimes: [], produtos: [], empregadores: [], originadores: [], idadeMaxima: 80, prazoMaximo: 96, taxas: [] };

  public id!: number | string | null;
  public nome!: string;
  public cnpj!: string;
  public banco!: string;
  public agencia!: string;
  public conta!: string;
  tipoContrato: string | null = null;
  afne: number = 0;
  ca: number | null = null;
}